import { MotifButton, MotifCard, MotifCardBody, MotifCardHeader } from '@ey-xd/motif-react';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ApprovalsQuestionsList from '../molecules/ApprovalsQuestionsList';
import ApprovalQuestionDetails from '../molecules/ApprovalQuestionDetails';
import { useParams } from 'react-router-dom';
import axios from "axios";
import { useLocation } from 'react-router-dom';

const ApprovalsUpdate = () => {
  const location = useLocation();
  const qstnIndex = location.state;

  const { workspaceId } = useParams();
  const { userDetails } = useSelector((state: any) => state.user);


  const navigate = useNavigate();
  const { users } = useSelector((state: any) => state.admin);
  const dispatch = useDispatch();
  const { access } = useSelector((state: any) => state.user);

  const [questionsList, setQuestionsList] = useState<any>([]);
  const [selectedQuestion, setSelectedQuestion] = useState(qstnIndex);

  const handleItemClick  = (questionIndex: number) => {
    setSelectedQuestion(questionIndex);
  };

  const engagementQuestions = async () => {
    try {
      const response = await axios.get(`/approvalList/${workspaceId}`);
      const questions = response?.data;
      setQuestionsList(questions);
    } catch(err) {
      console.log("error", err);
    }
  }

  const approveBtnClicked = async (data) => {
    try {
      const response = await axios.patch(`/questionnaire-approval/${data?.Id}`);
      if (response) {
        dispatch({ type: "GLOBAL_TOAST_OPEN", payload: {message: "Customized query approved successfully", variant: "success",} });
        engagementQuestions()
      }
    } catch(err) {
      console.log("error", err);
    }
  }
      
const rejectBtnClicked = async (data) => {
  try {
    const response = await axios.patch(`/questionnaire-rejection/${data?.Id}`);
    if (response) {
      dispatch({ type: "GLOBAL_TOAST_OPEN", payload: {message: "Customized query rejected successfully", variant: "success",} });
      engagementQuestions()
    }
  } catch(err) {
    console.log("error", err);
  }
}

  useEffect(() => {
    if (access.read) {
      engagementQuestions()
    }
  }, [access]);

  useEffect(() => {
    if (userDetails?.isAdmin !== true) {
      navigate('/');
    }
  }, [userDetails]);

  if (userDetails?.isAdmin !== true) {
    return <></>;
  }

  return (
    <div className="flex flex-col min-h-full m-3">
      <MotifCard className="min-h-[50vh] !bg-[transparent]">
        <MotifCardHeader className="!py-0" style={{ borderBottom: '1px solid #ffffff26' }}>
          <div className="flex gap-10 items-center !justify-between !w-full">
            <h4 className="!py-3 !font-bold">Customized Query Approvals</h4>
          </div>
        </MotifCardHeader>
        <MotifCardBody className="!min-h-80">
          {access.read === false && <p className="text-center font-bold">Read access denied</p>}
          <div className="flex flex-col gap-3">
            <div className="flex gap-2">
              <div className="w-60 ">
                <ApprovalsQuestionsList
                  questionsList={questionsList}
                  onQuestionSelect={handleItemClick }
                  selectedQuestion={selectedQuestion}
                />
              </div>
              <div className="w-full">
                <ApprovalQuestionDetails approveBtnClicked={approveBtnClicked} rejectBtnClicked={rejectBtnClicked} onCancel={() => navigate(-1)} details={questionsList[selectedQuestion]}  />
              </div>
            </div>
          </div>
        </MotifCardBody>
      </MotifCard>
    </div>
  );
};

export default ApprovalsUpdate;
